export const fonts = {
  BentonSansWideBlack: "BentonSansWideBlack",
  BentonSansWideBold: "BentonSansWideBold",
  BentonSansBold: "BentonSansBold",
  BentonSansMedium: "BentonSansMedium",
  BentonSansRegular: "BentonSansRegular",
};
